import AdminTenantsPage from "@/pages/admin/AdminTenantsPage";
import { Network } from "lucide-react";

export default function Distributors() {
  return (
    <AdminTenantsPage
      portal="DISTRIBUTOR"
      title="Distributors"
      subtitle="Approve, suspend, reactivate, assign plans, impersonate, export or delete any Distributor tenant."
      entityLabel="Distributor"
      Icon={Network}
      testId="admin-distributors"
      rowTestPrefix="dist"
    />
  );
}
